import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { USER_ACCOUNT_TYPE } from '../../../constants';

@Component({
  standalone: false,
  selector: 'register-forms-wrapper',
  templateUrl: './register-forms-wrapper.component.html',
  styleUrls: ['./register-forms-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RegisterFormsWrapperComponent {
  @Input() activeTab: string;
  @Output() onAccountTypeChanged = new EventEmitter<string>();
  @Output() onFormChange = new EventEmitter<void>();

  public USER_ACCOUNT_TYPE = USER_ACCOUNT_TYPE;

  public changeTab(tab: string) {
    this.activeTab = tab;
    this.onAccountTypeChanged.emit(this.activeTab);
  }
}
